// src/components/strumenti/BobineCavo.js — W442. Bobine di cavo dati necessarie
import React from "react";
import { useCampi, Campo, Griglia, Risultato, Formula, Azzera, Avviso, fmt } from "./UiStrumento";
import { bobineCavo } from "../../utils/calcoliStrumenti";

export default function BobineCavo() {
  const { v, set, n, azzera } = useCampi({ punti:"", lung:"", scorta:"10", bobina:"305" });
  const r = bobineCavo(n("punti"), n("lung"), n("scorta"), n("bobina"));
  return (
    <div>
      <Griglia colonne={2}>
        <Campo etichetta="Punti rete (tratte)" valore={v.punti} onChange={set("punti")} placeholder="Es. 48"/>
        <Campo etichetta="Lunghezza media della tratta (m)" valore={v.lung} onChange={set("lung")} placeholder="Es. 35"/>
        <Campo etichetta="Scorta (%)" valore={v.scorta} onChange={set("scorta")} aiuto="Ricchezze, risalite, sfrido."/>
        <Campo etichetta="Metri per bobina" valore={v.bobina} onChange={set("bobina")} aiuto="305 m è la bobina standard (1000 ft)."/>
      </Griglia>
      {r && r.tratta > 90 && <Avviso>Tratta di {fmt(r.tratta, 1)} m: oltre i 90 m del permanent link previsti per il cablaggio in rame (vedi «Limite cavo Ethernet»).</Avviso>}
      {r && r.trattePerBobina === 0 && <Avviso>Una tratta è più lunga della bobina.</Avviso>}
      <Risultato settore="reti" titolo="Bobine necessarie" valore={r?.bobine ? String(r.bobine) : "—"}
        righe={r ? [["Metri totali con scorta", fmt(r.metri, 0) + " m"], ["Tratte intere per bobina", String(r.trattePerBobina)], ["Bobine contando solo i metri", String(r.bobineSoloMetri)]] : []}/>
      <Formula>Tratta = lunghezza media × (1 + scorta); bobine = il maggiore tra metri totali ÷ metri per bobina e punti ÷ tratte intere per bobina (una tratta non si giunta, quindi gli spezzoni avanzati non bastano per una tratta intera).</Formula>
      <Azzera onClick={azzera}/>
    </div>
  );
}
